export default {
  TOGGLE_DEVELOPER_MODE(state) {
    const newState = !state.developerEnabled;
    state.developerEnabled = newState;
    localStorage.setItem('developerMode', newState ? '1' : '0');
  },
  TOGGLE_DEBUG_API(state) {
    const newState = !state.debugApi;
    state.debugApi = newState;
    localStorage.setItem('debugApi', newState ? '1' : '0');
  },
  TOGGLE_SHOW_PERMISSIONS(state) {
    const newState = !state.showPermissions;
    state.showPermissions = newState;
    localStorage.setItem('showPermissions', newState ? '1' : '0');
  },
  TOGGLE_SHOW_REQUESTS(state) {
    const newState = !state.showRequests;
    state.showRequests = newState;
    localStorage.setItem('showRequests', newState ? '1' : '0');
  },
  TOGGLE_SHOW_RESPONSES(state) {
    const newState = !state.showResponses;
    state.showResponses = newState;
    localStorage.setItem('showResponses', newState ? '1' : '0');
  },

  SET_DEVELOPER_MODE(state, payload) {
    state.developerEnabled = payload;
    localStorage.setItem('developerMode', payload ? '1' : '0');
  },
  SET_DEBUG_API(state, payload) {
    state.debugApi = payload;
    localStorage.setItem('debugApi', payload ? '1' : '0');
  },
  SET_SHOW_PERMISSIONS(state, payload) {
    state.showPermissions = payload;
    localStorage.setItem('showPermissions', payload ? '1' : '0');
  },
  SET_SHOW_REQUESTS(state, payload) {
    state.showRequests = payload;
    localStorage.setItem('showRequests', payload ? '1' : '0');
  },
  SET_SHOW_RESPONSES(state, payload) {
    state.showResponses = payload;
    localStorage.setItem('showResponses', payload ? '1' : '0');
  },
  SET_LOG_LEVEL(state, payload) {
    state.logLevel = payload;
    localStorage.setItem('logLevel', payload);
  }
};
